"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
exports.__esModule = true;
var react_1 = require("react");
var useUpdate_1 = __importDefault(require("../useUpdate"));
var useDidMount_1 = __importDefault(require("../useDidMount"));
var useMemoizedFn_1 = __importDefault(require("../useMemoizedFn"));
var isObject_1 = __importDefault(require("../shared/isObject"));
var isFunction_1 = __importDefault(require("../shared/isFunction"));
var shared_1 = require("./shared");
var provider_1 = require("./provider");
var useDidUpdate_1 = __importDefault(require("../useDidUpdate"));
var useRequest = function useRequest(service, options) {
  if (options && !(0, isObject_1["default"])(options)) {
    throw Error('options is not a object');
  }
  var promisifyService = function promisifyService() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      // eslint-disable-next-line prefer-spread
      var result = (0, shared_1.getFinalService)(service).apply(null, args);
      if ((0, isFunction_1["default"])(result.then)) {
        result.then(function (res) {
          resolve(res);
        })["catch"](function (e) {
          return reject(e);
        });
      } else {
        resolve(result);
        console.error("service function \"".concat(service, "\" return value not a Promise"));
      }
    });
  };
  var globalRef = (0, react_1.useRef)({});
  var localOptions = (0, shared_1.getFinalOptions)(options);
  var manual = localOptions.manual,
    onSuccess = localOptions.onSuccess,
    onError = localOptions.onError,
    defaultLoading = localOptions.defaultLoading,
    defaultParams = localOptions.defaultParams,
    initialData = localOptions.initialData,
    formatter = localOptions.formatter,
    refreshDeps = localOptions.refreshDeps,
    deps = localOptions.deps,
    depsEnable = localOptions.depsEnable;
  var stateDependenciesRef = (0, react_1.useRef)({
    loading: false,
    data: false,
    error: false,
    params: false
  });
  var stateRef = (0, react_1.useRef)({
    loading: defaultLoading,
    data: initialData,
    error: null,
    params: defaultParams
  });
  var reRender = (0, useUpdate_1["default"])();
  var dispatch = (0, react_1.useCallback)(function (payload) {
    var shouldUpdateState = false;
    // eslint-disable-next-line guard-for-in
    for (var k in payload) {
      // @ts-ignore
      stateRef.current[k] = payload[k];
      // @ts-ignore
      if (stateDependenciesRef.current[k]) {
        shouldUpdateState = true;
      }
    }
    if (shouldUpdateState) {
      reRender();
    }
  }, []);
  var fetch = (0, useMemoizedFn_1["default"])(function (params, opts) {
    if (opts === void 0) {
      opts = {};
    }
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      args[_i - 2] = arguments[_i];
    }
    var _a = globalRef.current,
      globalOnSuccess = _a.onSuccess,
      globalOnError = _a.onError,
      globalOpts = _a.config;
    var assignedParams = (0, shared_1.assignParams)(params, defaultParams);
    dispatch({
      loading: true,
      params: assignedParams
    });
    return new Promise(function (resolve) {
      promisifyService.apply(void 0, __spreadArray([assignedParams, __assign(__assign({}, globalOpts), opts)], args, false)).then(function (data) {
        var formattedData = formatter(data);
        dispatch({
          data: formattedData,
          loading: false
        });
        if ((0, isFunction_1["default"])(onSuccess)) {
          onSuccess(formattedData, assignedParams);
        } else if ((0, isFunction_1["default"])(globalOnSuccess) && !(0, isFunction_1["default"])(onSuccess)) {
          globalOnSuccess(data, assignedParams);
        }
        resolve(data);
      })["catch"](function (error) {
        var enhancedError = (0, shared_1.enhanceError)(error);
        dispatch({
          error: enhancedError,
          loading: false
        });
        if ((0, isFunction_1["default"])(onError)) {
          onError(enhancedError, assignedParams);
        } else if ((0, isFunction_1["default"])(globalOnError) && !(0, isFunction_1["default"])(onError)) {
          globalOnError(enhancedError);
        }
      });
    });
  });
  // 重置
  var reset = (0, react_1.useCallback)(function () {
    dispatch({
      loading: defaultLoading,
      data: initialData,
      params: defaultParams,
      error: null
    });
  }, []);
  // 手动启动
  var run = function run(params) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    return Promise.resolve(fetch.apply(void 0, __spreadArray([params], args, false)));
  };
  // 刷新
  var refresh = function refresh() {
    return Promise.resolve(fetch(stateRef.current.params));
  };
  var setData = function setData(setter) {
    var nextData = setter(stateRef.current.data);
    if (nextData) {
      dispatch({
        data: nextData
      });
    }
  };
  (0, useDidMount_1["default"])(function () {
    var _a;
    // 应用全局工具函数
    var app = (0, provider_1.requestApply)();
    globalRef.current = (_a = app === null || app === void 0 ? void 0 : app.getGlobal()) !== null && _a !== void 0 ? _a : {};
    // 手动请求关闭并且依赖参数为空时
    if (!manual && !deps.length) {
      fetch(defaultParams);
    }
  });
  (0, react_1.useEffect)(function () {
    if (!deps.length) return;
    var params = depsEnable === null || depsEnable === void 0 ? void 0 : depsEnable.apply(void 0, deps);
    if (!!params) {
      var nextParams = (0, shared_1.assignParams)(params, defaultParams);
      fetch(params);
    }
  }, deps);
  (0, useDidUpdate_1["default"])(function () {}, refreshDeps);
  return (0, react_1.useMemo)(function () {
    var state = {
      setData: setData,
      reset: reset,
      refresh: refresh,
      run: run
    };
    Object.defineProperties(state, {
      loading: {
        get: function get() {
          stateDependenciesRef.current.loading = true;
          return stateRef.current.loading;
        }
      },
      data: {
        get: function get() {
          stateDependenciesRef.current.data = true;
          return stateRef.current.data;
        }
      },
      error: {
        get: function get() {
          stateDependenciesRef.current.error = true;
          return stateRef.current.error;
        }
      }
    });
    return state;
  }, [refresh]);
};
exports["default"] = useRequest;